import {Component, DoCheck, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService, SocialLoginService, UserService} from '../_services';
import {UserContext} from '../_context/user.context';
import {CookieService} from 'ngx-cookie';
import {SharedService} from '../shared/shared.service';
import {Constants} from '../shared/Helpers/constants';
import {environment} from '../../environments/environment';
import {HttpResponse} from '@angular/common/http';
import * as moment from 'moment';
import { ILastUserAccess } from '../shared/interfaces';
import { AuthenticationMethodEnum, SocialProviderNameEnum } from '../enums/enums';
import Swal from 'sweetalert2';
import { Alert, AlertTypeEnum } from '../shared/Helpers/Alert';

@Component({
  selector: 'app-specific-place-login',
  templateUrl: './specific-place-login.component.html',
  styles: ['.cursor-pointer {cursor:pointer}']
})
export class SpecificPlaceLoginComponent implements OnInit, OnDestroy, DoCheck {
  public checkFirstLogin: boolean = false;
  public passwordMode;
  public type;
  public model: any = {};
  public loading = false;
  public peopleData: any;
  public passwordDaysExpire: number;
  public hasExpired: boolean;
  public controlPasswordExpired: boolean = false;
  public isLiberateUser: boolean = false;
  public userNameValidated: any;
  public nextStep: boolean = false;
  public firstStep: boolean = true;
  public LoggedInUserList: Array<ILastUserAccess> | any;
  public LoggedInUserListCheck: boolean;
  public avatar: any;
  public logoPath: any = null;
  public passwordExpiry: boolean = false;
  public SocialProviderNameEnum: typeof SocialProviderNameEnum = SocialProviderNameEnum;
  public facebookEnabled: boolean = false;
  public googleEnabled: boolean = false;
  public linkedinEnabled: boolean = false;

  private hostname: any;
  private returnUrl: string;
  private LastUserAccess: ILastUserAccess
  private ListLastUserAccess: Array<ILastUserAccess>;
  private currentloginDate: any;
  private firstLoginDataPeople: Date;
  private organisationId = environment.organisation_id;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private userContext: UserContext,
    private cookieService: CookieService,
    public sharedService: SharedService,
    private socialLoginService: SocialLoginService
  ) {
    this.userContext = new UserContext();
  }

  ngOnInit() {
    this.initLastUsersAccess();
    // reset login status
    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'];
    this.checkIfSamlRequest();
    this.getHostName();
    this.initProperites();
    this.checkIfUserIsAuthenticated();
    this.getLastUsersAccessed();
    this.getEnabledSocialProviders();
  }

  ngOnDestroy() {
    this.sharedService.changeReturnUrl(this.returnUrl);
  }

  ngDoCheck() {
    if (this.sharedService.loadedOrganisationByUrl.value) {
      if (this.sharedService.loginCustomisation.value != undefined && this.sharedService.loginCustomisation.value != null) {
        if (this.sharedService.LogoImage.value != null) {
          this.logoPath = null;
          this.logoPath = this.sharedService.LogoImage.value;
        } else {
          this.logoPath = Constants.logoPath;
        }
      } else {
        this.logoPath = Constants.logoPath;
      }
    } else {
      this.logoPath = Constants.logoPath;
    }
  }

  private initLastUsersAccess() {
    this.LastUserAccess = {} as ILastUserAccess
    this.ListLastUserAccess = [] as Array<ILastUserAccess>;
  }

  private getHostName() {
    if (this.returnUrl != undefined) {
      if (this.returnUrl.toString().trim().length > 1) {
        const parser = document.createElement('a');
        parser.href = this.returnUrl
        this.hostname = parser.host;
      }
    }
  }

  private initProperites() {
    this.passwordMode = true;
    this.type = 'password';
    this.controlPasswordExpired = false;
    this.passwordExpiry = false;
  }

  private checkIfUserIsAuthenticated() {
    if (localStorage.getItem(Constants.localStorage_currentUser)) {
      this.returnUrl = environment.default_return_url;
      if (this.userContext.isAuthenticated && this.userContext.userID && this.userContext.organisationID) {
      }
      else {
        localStorage.removeItem(Constants.localStorage_currentUser);
      }
    }
  }

  private getLastUsersAccessed() {
    if (localStorage.getItem(Constants.localStorage_ListUsers) != undefined && localStorage.getItem(Constants.localStorage_ListUsers)?.length! > 0) {
      const LastUserLoggedIn = localStorage.getItem(Constants.localStorage_ListUsers);
      const usersArrayResult: Array<any> = JSON.parse(LastUserLoggedIn);
      this.LoggedInUserList = usersArrayResult.reverse().slice(Constants.minUsersList, Constants.maxUsersList)
      this.updateAvatars();
      this.LoggedInUserListCheck = true;
      this.firstStep = false;

    } else {
      this.LoggedInUserList = [];
      this.LoggedInUserListCheck = false;
      this.firstStep = true;
    }
  }

  private updateAvatars() {
    for (let i = 0; i < this.LoggedInUserList.length; i++) {
      this.userService.checkUsernameAuthenticationWithOrganisation(this.LoggedInUserList[i].username, this.organisationId).subscribe((data: any) => {
        this.LoggedInUserList[i].avatar = data.body.avatar;
        if (i == this.LoggedInUserList.length - 1) {
          localStorage.removeItem(Constants.localStorage_ListUsers);
          localStorage.setItem(Constants.localStorage_ListUsers, JSON.stringify(this.LoggedInUserList))
        }
      });
    }
  }

  public login() {
    this.loading = true;
    if (this.checkFormModel()) {
      this.currentloginDate = moment.utc().subtract(4, 'seconds').toISOString();

      this.authenticationService.loginWithAuthenticatingOrganisation(this.model.username, this.model.password, this.organisationId).subscribe({
        next: (data) => {
          this.sharedService.changeCurrentOrganisationId(null);
          // add cookie

          let idamUrl: string = environment.identityCookieUrl;
          idamUrl = idamUrl.substr( idamUrl.indexOf('//') + 2);
          idamUrl = idamUrl.substr(0, idamUrl.indexOf(':'));
          if (idamUrl.indexOf('.') > -1) { idamUrl = idamUrl.substr( idamUrl.indexOf('.')); }
          this.cookieService.put('ABLEIDENTITY', data.body.token,{path: '/', expires: moment(new Date()).add(30, 'm').toDate(), domain: idamUrl});
          // check if is authenticated another user
          const user = data.body;
          if (localStorage.getItem(Constants.localStorage_currentUser)) {

            this.userContext = new UserContext();
            // if he is authenticated with username and password, and with 2fa if required, so if token is contextualized
            if (this.userContext.isAuthenticated && this.userContext.organisationID && this.userContext.userID) {
              // it is already contextualized
              if (this.userContext.userName === this.model.username) {
                this.returnUrl = environment.default_return_url;
              } else {
                Alert.basicNotification(AlertTypeEnum.Warning, "Warning", `'You are already signed in with another account: ${this.userContext.userName}  ${this.userContext.createdToken}`);
                this.loading = false;
              }
            } else {
              if (user && user.token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem(Constants.localStorage_currentUser, JSON.stringify(user));
              }
              this.getPeopleData();
            }

          } else {
            if (user && user.token) {
              // store user details and jwt token in local storage to keep user logged in between page refreshes
              localStorage.setItem(Constants.localStorage_currentUser, JSON.stringify(user));
            }
            this.getPeopleData();
          }
          this.checkIfSamlRequestExistsInLocalStorage();
        },
        error: (error) => {
          if (error.status === 401) {
            if (error.error.errorCode == 1014) {
              Alert.basicNotification(AlertTypeEnum.Error, "Login error", "You do not currently have permission to log in. Please contact your Able+ administrator if you believe you should have access.")
            } else if (error.error.errorCode === 1013) {
              Alert.basicNotification(AlertTypeEnum.Error, "Login error", "Person does not have home user.");
            } else if (error.error.errorCode === 1015) {
              if (error.error.detailedMessage.toString() === 'Organisation is suspended') {
                Alert.basicNotification(AlertTypeEnum.Error, "Login error", "Your organisation has been suspended. Please contact your administrator.");
              } else {
                Alert.basicNotification(AlertTypeEnum.Error, "Login error", "This user account has been deleted. Please contact your administrator.");
              }
            } else if (error.error.errorCode == 1004) {
              Alert.basicNotification(AlertTypeEnum.Error, "Login error", "Your username or password is incorrect.");
            } else if (error.error.errorCode == 1070) {
              Alert.basicNotification(AlertTypeEnum.Error, "Login error", error.error.detailedMessage.toString());
            }
            else {
              Alert.basicNotification(AlertTypeEnum.Error, "Login error", "Your credentials were not correct. Please check your username and password and try again.");
            }
          } else if (error.status === 404 || error.status === 0) {
            Alert.basicNotification(AlertTypeEnum.Error, "Login error", "You appear to be offline. Please check your connection and try again.");
          } else {
            Alert.basicNotification(AlertTypeEnum.Error, "Login error", "An error occurred. Please try again later.");
          }
          this.loading = false;
        }
      });
    }
  }

  private checkFormModel(): boolean {
    if ((this.model.username != undefined && this.model.username != undefined) && (this.model.password != undefined && this.model.password != undefined)) {
      return true;
    }
    return false;
  }

  public usernameValidation() {
    this.userService.checkUsernameAuthenticationWithOrganisation(this.model.username, this.organisationId).subscribe({
      next: (data) => {
        this.firstStep = true;
        const response = data.body;
        this.userNameValidated = this.model.username;
        this.avatar = response.avatar;

        if (response.authenticationMethod == AuthenticationMethodEnum.Managed) {
          this.nextStep = true;
          this.LastUserAccess.avatar = response.avatar;
          this.LastUserAccess.username = this.userNameValidated;
        } else if (response.authenticationMethod == AuthenticationMethodEnum.Federated) {
          this.LastUserAccess.avatar = response.avatar;
          this.LastUserAccess.username = this.userNameValidated;
          this.checkUsernameOnLocalStorage(this.LastUserAccess);
          this.isLiberateUser = true;
          window.location.href = response.url;
        }
      },
      error: (err) => {
        if(err.error.errorCode == 1004) {
          Alert.basicNotification(AlertTypeEnum.Error, "Username error", `The username that you have entered does not exist in this organisation. Please check that you have selected the correct organisation and that the username you entered is correct.`);
        } else {
          Alert.basicNotification(AlertTypeEnum.Error, "Username error", "Username could not be found. Please check your username and try again.");
        }
        this.loading = false;
      }
    })
  }

  private checkUsernameOnLocalStorage(userAccess: ILastUserAccess) {
    if (localStorage.getItem(Constants.localStorage_ListUsers) != undefined && localStorage.getItem(Constants.localStorage_ListUsers)?.length > 0) {
      let LastUserLoggedIn = localStorage.getItem(Constants.localStorage_ListUsers);
      this.ListLastUserAccess = JSON.parse(LastUserLoggedIn)
      this.ListLastUserAccess = this.ListLastUserAccess.slice(Constants.minUsersList, Constants.maxUsersList);
      if (this.ListLastUserAccess.filter(item => item.username == userAccess.username).length == 0) {
        if (this.ListLastUserAccess.length < 5) {
          this.ListLastUserAccess.push(userAccess)
          localStorage.setItem(Constants.localStorage_ListUsers, JSON.stringify(this.ListLastUserAccess));

        } else {
          this.ListLastUserAccess.slice(Constants.maxUsersList);
          this.ListLastUserAccess.push(userAccess)
          localStorage.setItem(Constants.localStorage_ListUsers, JSON.stringify(this.ListLastUserAccess));
        }
      } else {
        // remove
        this.ListLastUserAccess = this.ListLastUserAccess.filter(item => item.username != userAccess.username)
        // push again(get updated avatar)
        this.ListLastUserAccess.push(userAccess);
        localStorage.setItem(Constants.localStorage_ListUsers, JSON.stringify(this.ListLastUserAccess));
      }

    } else {
      this.ListLastUserAccess.push(userAccess);
      localStorage.setItem(Constants.localStorage_ListUsers, JSON.stringify(this.ListLastUserAccess));
    }
  }

  onKeyDown(event, isValid) {
    if (event.keyCode == 13) {
      if (this.nextStep && !this.isLiberateUser) {
        if (isValid) {
          this.login();
        }
      }
      else {
        this.usernameValidation();
      }
    }
  }

  private async getPeopleData() {
    const currentUser = new UserContext();
    if (currentUser.isAuthenticated) {

      this.userService.getPeopleById(currentUser.personID).subscribe({
        next: (data) => {
          this.peopleData = data.body;
          this.firstLoginDataPeople = this.peopleData.firstLoginDate;
          this.checkPasswordExpiry();
        },
        error: (error) => {
          if (error.status === 0) {
            this.checkFirstLogin = false;
            this.controlPasswordExpired = true;
            this.hasExpired = true;
            this.peopleData = {};
            this.passwordExpiry = true;

          } else if (error.status === 401) {
            if (error.error.errorCode === 1012) {
              this.checkFirstLogin = true;
            } else if (error.error.errorCode === 1010) {
              this.checkFirstLogin = false;
            }
            this.sharedService.storeFirstLoginForExpiryPassword(this.checkFirstLogin);
            this.controlPasswordExpired = true;
            this.hasExpired = true;
            this.peopleData = {};
            this.passwordExpiry = true;
          }
        }
      })
    }
  }

  // TODO: replace current method with this one once the domain problem is fixed
  private contextualizeByOrganisationHostname() {
    // If no organisation was found contextualize token by user's home organisation
    this.userService.getHomeUser(this.peopleData.id).subscribe((userData) => {
      const user = userData.body;
      const filterUser = user.filter(item => item.isHomeUser == true);
      this.sharedService.changeCurrentOrganisationId(filterUser[0].organisation.id);
      this.sharedService.changeLoggedUserId(filterUser[0].id);
      this.contextualizeToken(filterUser[0].organisation.id);
    });
  }

  // contextualize Token
  private contextualizeToken(organisationId: any) {
    this.userService.contextualizeToken(organisationId).subscribe({
      next: (data) => {
        if (data.status == 200) {
          const user = data.body;
          localStorage.setItem(Constants.localStorage_currentUser, JSON.stringify(user));
          this.authenticationService.redirect(this.returnUrl);
        }
      },
      error: (err) => {
        if (err.error.errorCode === 1016) {
          // 2fa required, but no configurations for 2fa
          this.getUserIdByErrorMsg(err.error.detailedMessage);
          this.router.navigateByUrl('/2FA-setup');
        }
        // 2fa required and code sent to the last configured method (sms/app)
        else if (err.error.errorCode === 1017) {
          const errMsg: string = err.error.detailedMessage;
          this.getUserIdByErrorMsg(errMsg);
          this.router.navigateByUrl('/2FA-authentication');
        }
        // 2fa required, but the setup of app not fully completed
        else if (err.error.errorCode === 1018) {
          this.getUserIdByErrorMsg(err.error.detailedMessage);
          this.router.navigateByUrl('/2FA-authentication');
        }
        else if (err.status === 422 && err.error.errorCode === 1006) {
          const currentUser = new UserContext();
          this.sharedService.setErrorMsg(err.error.detailedMessage);
          if (!this.sharedService.loggedUserId.value) {
            this.userService.getHomeUser(currentUser.personID).subscribe({
              next: (res) => {
                const userId = res.body.find(usr => usr.organisation.id == organisationId).id;
                if (userId) {
                  this.sharedService.changeLoggedUserId(userId)
                }
                else {
                  this.sharedService.changeLoggedUserId(this.peopleData.homeUser.id)
                }
              },
              error: (err) => {
                this.sharedService.changeLoggedUserId(this.peopleData.homeUser.id);
              },
              complete: () => {
                this.router.navigateByUrl('/2FA-authentication');
              }
            })
          }
          else {
            this.router.navigateByUrl('/2FA-authentication');
          }
        }
      }
    })
  }

  private getUserIdByErrorMsg(errMsg) {
    const userId: string = errMsg.substr(errMsg.indexOf("\'") + 1, 36);
    this.sharedService.changeLoggedUserId(userId);
  }

  // check password exiry
  private checkPasswordExpiry() {
    // check if password expired date is less than 7 days.
    // Get the current date
    const todayDate = new Date();
    // Set start/end dates to a specified date
    const expiryDate = new Date(this.peopleData.passwordExpiryDate);

    // Compare the two dates
    const duration = Math.floor((Date.UTC(expiryDate.getFullYear(), expiryDate.getMonth(), expiryDate.getDate())
      - Date.UTC(todayDate.getFullYear(), todayDate.getMonth(), todayDate.getDate())) / (1000 * 60 * 60 * 24));

    this.passwordDaysExpire = duration;

    if (this.passwordDaysExpire <= 7) {
      this.userService.checkPeopleLastAccess(this.peopleData.id).subscribe((data) => {
        const checkLastAccess = data.body;

        if (checkLastAccess.shouldDisplayMessage) {
          if (duration <= 7 && duration > 2) {
            this.controlPasswordExpired = true;
            this.passwordExpiry = true;
            // show popup to reset password or to skip it
          } else if (duration <= 2) {
            if (duration <= 0) {
              this.controlPasswordExpired = true;
              this.hasExpired = true;
              this.passwordExpiry = true;
            } else {
              this.controlPasswordExpired = true;
              this.passwordExpiry = true;
            }
          } else {
            this.enterContextualisation();
          }
        } else {
          if (duration <= 2) {
            if (duration <= 0) {
              this.controlPasswordExpired = true;
              this.hasExpired = true;
              this.passwordExpiry = true;
            } else {
              this.controlPasswordExpired = true;
              this.passwordExpiry = true;
            }
          } else {
            this.enterContextualisation();
          }
        }
        if (this.firstStep && !this.passwordExpiry &&
          (!this.controlPasswordExpired || !this.LoggedInUserListCheck ||
            (!this.controlPasswordExpired && !this.LoggedInUserListCheck)
          )
        ) {

        } else {
        }
      });
    } else {
      if (this.compareFirstLoginWithCurrentLoginDate(this.firstLoginDataPeople, this.currentloginDate)) {
        this.getOrganisationIdByUrl();
      } else {
        this.enterContextualisation();
      }
    }
  }

  private compareFirstLoginWithCurrentLoginDate(firstLoginDate, currentLoginDate: string): boolean {
    return (firstLoginDate > currentLoginDate) ? true : false;
  }

  public getOrganisationIdByUrl() {
    if (this.hostname !== environment.default_return_url && ((this.returnUrl != undefined || this.returnUrl != null) && this.returnUrl != environment.default_return_url)) {
      this.getOrganisationIdByHomeUser();
    } else {
      this.getOrganisationIdByHomeUser();
    }
  }

  getOrganisationIdByHomeUser() {
    this.userService.getHomeUser(this.peopleData.id).subscribe((userData) => {
      const filterUser = userData.body.filter(item => item.isHomeUser == true);
      this.sharedService.changeCurrentOrganisationId(filterUser[0].organisation.id);
      this.sharedService.changeLoggedUserId(filterUser[0].id)
      this.checkIfSecurityQuestions(filterUser[0]);
    });
  }

  getUserByOrganisationId(organisationId: string) {
    this.userService.getHomeUser(this.peopleData.id).subscribe((userData) => {
      const user = userData.body.find(usr => usr.organisation.id == organisationId);
      if (user && user.id) {
        this.sharedService.changeLoggedUserId(user.id)
        this.checkIfSecurityQuestions(user);
      }
      else {
        const homeUser = userData.body.find(item => item.isHomeUser == true)
        this.checkIfSecurityQuestions(homeUser);
      }
    });
  }

  public checkIfSecurityQuestions(userObj: any) {
    if (this.sharedService.currentOrganisationId.value) {
      this.userService.getSecurityQuestions(userObj.userType.id, this.sharedService.currentOrganisationId.value)
        .subscribe((resp) => {
          const securityQuestionsUserType = resp.body;
          if (securityQuestionsUserType.length > 0) {
            this.userService.getIdentityById(this.peopleData.identityType.id)
              .subscribe({
                next: (res) => {
                  const identityType = res.body;
                  if (identityType.minSecurityQuestionCount && securityQuestionsUserType.length >= identityType.minSecurityQuestionCount) {
                    return this.router.navigateByUrl('/security-questions');
                  }
                  else {
                    this.enterContextualisation();
                  }
                },
                error: () => {
                  this.enterContextualisation();
                }
              });
          }
          else {
            this.enterContextualisation();
          }
        });
    }
  }

  public enterContextualisation() {
    if (this.sharedService.currentOrganisationId.value) {
      this.contextualizeToken(this.sharedService.currentOrganisationId.value);
    }
    else {
      if (this.hostname !== environment.default_return_url &&
        ((this.returnUrl != undefined || this.returnUrl != null) && this.returnUrl != environment.default_return_url)) {
        this.contextualizeByOrganisationHostname();
      } else {
        this.userService.getHomeUser(this.peopleData.id).subscribe((userData) => {
          const user = userData.body;
          const filterUser = user.filter(item => item.isHomeUser == true);
          this.sharedService.changeCurrentOrganisationId(filterUser[0].organisation.id);
          this.sharedService.changeLoggedUserId(filterUser[0].id)
          this.contextualizeToken(filterUser[0].organisation.id);
        });
      }
    }
  }

  public passwordModeOn() {
    this.passwordMode = true;
    this.type = 'password';
  }

  public passwordModeOff() {
    this.passwordMode = false;
    this.type = 'text';
  }

  public onSkip() {
    this.passwordExpiry = false;
    this.enterContextualisation();
  }

  public onReset() {
    this.passwordExpiry = false;
    this.router.navigate(['reset-password']);
  }

  public onUserFromList(user) {
    if (user != undefined || user != null) {
      this.model.username = user;
      this.usernameValidation();
    }
  }

  public onRemoveAccount() {
    this.model = {};
    this.nextStep = false;
    this.loading = false;
    this.sharedService.changeCurrentOrganisationId(null);
  }

  public onRemoveAccountFromList(user) {
    if (localStorage.getItem(Constants.localStorage_ListUsers) != undefined && localStorage.getItem(Constants.localStorage_ListUsers)?.length > 0) {
      const LastUserLoggedIn = localStorage.getItem(Constants.localStorage_ListUsers);
      this.LoggedInUserList = JSON.parse(LastUserLoggedIn);
      ///check if exist;
      if (this.LoggedInUserList.filter(item => item.username == user).length > 0) {
        this.LoggedInUserList = this.LoggedInUserList.filter(item => item.username != user);

        if (this.LoggedInUserList.length == 0) {
          this.removeLastUserInit();
        } else {
          localStorage.setItem(Constants.localStorage_ListUsers, JSON.stringify(this.LoggedInUserList));
          const LastUserLogged: any = localStorage.getItem(Constants.localStorage_ListUsers);
          this.LoggedInUserList = JSON.parse(LastUserLogged);
          this.LoggedInUserListCheck = true;
          this.firstStep = false;
        }
      }
    }
  }

  private removeLastUserInit() {
    localStorage.removeItem(Constants.localStorage_ListUsers);
    this.firstStep = true;
    this.LoggedInUserListCheck = false;
    this.controlPasswordExpired = false;
    this.LoggedInUserList = [];
  }

  public authenticateAsNewUser() {
    this.firstStep = true;
  }

  private checkIfSamlRequest() {
    if ( this.route.snapshot.queryParams['SAMLRequest']) {
      let samlRequest = this.route.snapshot.queryParams['SAMLRequest'];
      let relayState  = this.route.snapshot.queryParams['RelayState'];
      let tenant = this.route.snapshot.queryParams['tenant'];
      let orgIds = this.route.snapshot.queryParams['orgIds'];
      let method = this.route.snapshot.queryParams['method'];
      let objectForLStorage = {
        samlRequest:samlRequest,
        relayState:relayState,
        tenant:tenant,
        orgIds:orgIds,
        method:method
      };
      localStorage.setItem("samlRequest",JSON.stringify(objectForLStorage));
      this.router.navigateByUrl('/login');
    }
  }

  private checkIfSamlRequestExistsInLocalStorage() {
    if(localStorage.getItem("samlRequest")) {
      let data: any = JSON.parse(localStorage.getItem("samlRequest"));
      localStorage.removeItem("samlRequest");
      let queryParam: string;
      queryParam="?tenant=tenant1";
      if(data.method == "POST"){
        let bodyPost="SAMLRequest="+encodeURIComponent(data.samlRequest)+"&RelayState="+encodeURIComponent(data.relayState);
        if(data.orgIds!=null&&data.orgIds!=""){
          this.authenticationService.samlSsoRequest(data.requestUrl,data.orgIds,"POST",queryParam,bodyPost).subscribe(data => {
            this.openWindow(data);
          })
        }
        else {
          this.authenticationService.samlSsoRequestWithoutOrg("POST",queryParam,bodyPost).subscribe(data => {
            this.openWindow(data);
          })
        }
      }
      else{
        queryParam+="&SAMLRequest="+encodeURIComponent(data.samlRequest)+"&RelayState="+encodeURIComponent(data.relayState);
        if(data.orgIds!=null&&data.orgIds!=""){
          this.authenticationService.samlSsoRequest(data.requestUrl,data.orgIds,"GET",queryParam).subscribe(data => {
            this.openWindow(data);
          })
        }
        else {
          this.authenticationService.samlSsoRequestWithoutOrg("POST",queryParam).subscribe(data => {
            this.openWindow(data)
          })
        }
      }
    }
  }

  private openWindow(data: HttpResponse<string>) {
    let markup: any = data.body;
    let wnd: any = window.open('about:blank', '');

    if (!wnd || wnd.closed || typeof wnd == 'undefined' || typeof wnd.closed == 'undefined') {
      let msg: any = '<p> Your browser is blocking pop ups, please allow them and click here to be redirected</p>';
      Swal.fire({
        title: 'Allow popup',
        html: msg,
        showCancelButton: false,
        showConfirmButton: true,
        confirmButtonText: 'Click here',
        customClass: 'sweetalert-lg',
        width: '500px'
      }).then((result) => {
        var wnd: any = window.open("about:blank", "");
        wnd.document.write(markup);
        wnd.document.close();
        var win: any = window.open("about:blank", "_self");
        win.close();
        window.close();
      });
    } else {
      wnd.document.write(markup);
      wnd.document.close();
      window.close();
    }
  }

  public onLoginWithSocialClick(socialProviderName: String) {
    this.socialLoginService.socialLoginAuthorizationUrl(socialProviderName).subscribe( res => {
      if (res) {
        window.location.href = res.toString();
      }
    });
  }

  private getEnabledSocialProviders() {
    this.socialLoginService.getThirdPartyAuthentications(this.organisationId).subscribe(res => {
      res.body.forEach( element => {
        if (element.accountTypeId == 1) {
          this.facebookEnabled = element.fbEnabled;
          this.googleEnabled = element.googleEnabled;
          this.linkedinEnabled = element.linkedInEnabled;
        }
      });
    });
  }
}
